// import React, { useState } from "react";
// import experience from "./data/experience.json";
// // import "./Experience.css";

// const Experience = () => {
//   const [popupImage, setPopupImage] = useState(null);

//   const openPopup = (imageSrc) => {
//     setPopupImage(imageSrc);
//   };

//   const closePopup = () => {
//     setPopupImage(null);
//   };

//   return (
//     <>
//       <section className="experience-section" id="experience">
//         <div className="container">
//           <h1 className="text-center section-title">Experience</h1>
//           <div className="experience-list">
//             {experience.map((data) => (
//               <div
//                 key={data.id}
//                 className="experience-card"
//                 data-aos="zoom-in"
//                 data-aos-duration="1000"
//               >
//                 <div
//                   className="experience-image flex justify-center"
//                   onClick={() => openPopup(`/assets/${data.imageSrc}`)}
//                 >
//                   <img src={`/assets/${data.imageSrc}`} alt={data.role} />
//                 </div>
//                 <div className="experience-details">
//                   <h4 className="experience-role">{data.role}</h4>
//                   <p className="roleDiscription"> {data.roleDiscription} </p>
//                   <h6 className="projectName">{data.projectsName}</h6>
//                   <p className="projectDiscription">{data.projectDiscription}</p>
//                   {data.experiences.map((exp, idx) => (
//                     <p key={idx} className="experience-text">
//                       {exp}
//                     </p>
//                   ))}
//                   <div className="experience-meta flex justify-between">
//                     <span className="experience-location">
//                       {data.location}
//                     </span>
//                     <span className="experience-dates">
//                       {data.startDate} - {data.endDate || "Present"}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Popup Modal */}
//       {popupImage && (
//         <div className="popup-modal">
//           <div className="popup-overlay" onClick={closePopup}></div>
//           <div className="popup-content">
//             <img src={popupImage} alt="Popup" />
//             <button className="close-button" onClick={closePopup}>
//               X
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Experience;

import React, { useState } from "react";
import experience from "./data/experience.json";
// import "./Experience.css";

const Experience = () => {
  const [popupImage, setPopupImage] = useState(null);

  const openPopup = (imageSrc) => {
    setPopupImage(imageSrc);
  };

  const closePopup = () => {
    setPopupImage(null);
  };

  return (
    <>
      <section className="experience-section" id="experience">
        <div className="container">
          <h1 className="text-center section-title">Experience</h1>
          <div className="experience-list">
            {experience.map((data) => (
              <div
                key={data.id}
                className="experience-card"
                data-aos="zoom-in"
                data-aos-duration="1000"
              >
                <div
                  className="experience-image flex justify-center"
                  onClick={() => openPopup(`/assets/${data.imageSrc}`)}
                >
                  <img src={`/assets/${data.imageSrc}`} alt={data.role} />
                </div>
                <div className="experience-details">
                  <h3 className="experience-role">{data.role}</h3>
                  <p className="roleDiscription"> {data.roleDiscription} </p>
                  <h5 className="projectName">{data.projectsName}</h5>
                  <p className="projectDiscription">{data.projectDiscription}</p>
                  {data.experiences.map((exp, idx) => (
                    <p key={idx} className="experience-text">
                      {exp}
                    </p>
                  ))}
                  <div className="experience-meta flex justify-between">
                    <span className="experience-location">
                      {data.location}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popup Modal */}
      {popupImage && (
        <div className="popup-modal">
          <div className="popup-overlay" onClick={closePopup}></div>
          <div className="popup-content">
            <img src={popupImage} alt="Popup" />
            <button className="close-button" onClick={closePopup}>
              X
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Experience;
